import setPayManualAndPayInfullState from './setPayManualAndPayInfullState';

const setPaymentPlanStates = (state, action) => {
  const { paymentPlanOptions, currentAmountDue } = action.payload;
  state.paymentPlanOptions = paymentPlanOptions;
  state.amountDue = currentAmountDue;
  setPayManualAndPayInfullState(state, { payload: paymentPlanOptions });
};

export default setPaymentPlanStates;
